import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import TransactionInvoicesTable from "./components/TransactionInvoicesTable";
import PageWrapper from "app/modules/shared/PageWrapper";
import { useSelector } from "react-redux";
import { selectTransactionInvoices } from "./components/TransactionInvoicesTableSlice";
import { useParams } from "react-router-dom";

const TransactionInvoicesTablePage: React.FC = () => {
  const transactionInvoices = useSelector(selectTransactionInvoices);
  const { clientID } = useParams();

  return (
    <CPLAnalytics pageName="Invoice Charges">
      <PageWrapper
        title={`Invoice Charges For ${transactionInvoices.invoiceNumber}`}
        backTo={`/ClientTransactions/${clientID}`}
        data-test-id="invoice-charges__back-button"
      >
        <TransactionInvoicesTable />
      </PageWrapper>
    </CPLAnalytics>
  );
};

export default TransactionInvoicesTablePage;
